module.exports = require("react-collapse");


/*****************
 ** WEBPACK FOOTER
 ** external "react-collapse"
 ** module id = 80
 ** module chunks = 0
 **/